$(document).ready(function(){
	
	$(".product-tabs .tab").on("click", function (evt) {
      evt.preventDefault();
      $(this).addClass("active");
      $(this).siblings().removeClass("active");
      var sel = this.getAttribute("data-toggle-target");
      $(".product-tabs .tab-content")
        .removeClass("active")
        .filter(sel)
        .addClass("active");
    });

})